import { render, staticRenderFns } from "./PricingsSummary.vue?vue&type=template&id=5624b694"
import script from "./PricingsSummary.vue?vue&type=script&lang=js"
export * from "./PricingsSummary.vue?vue&type=script&lang=js"
import style0 from "./PricingsSummary.vue?vue&type=style&index=0&id=5624b694&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports